import { FunctionComponent } from 'react'

import { ICardProps } from './CardComponent.types'
import { Container } from './styles'

const Card: FunctionComponent<ICardProps> = ({
  children,
  onClick,
  className,
}) => (
  <Container onClick={onClick} className={className}>
    {children}
  </Container>
)

export default Card
